import React, { useEffect } from "react";

import "./styles.css";

const AccessibilityBar = () => {
  useEffect(() => {
    (function getThemeAndFontSize() {
      const theme = localStorage.getItem("@Ceprevi:theme");
      const fontSize = localStorage.getItem("@Ceprevi:fontSize");

      if (theme) {
        switch (theme) {
          case "1":
            changeColors(1);
            break;
          case "2":
            changeColors(2);
            break;
          case "3":
            changeColors(3);
            break;
          default:
            changeColors(1);
        }
      }

      if (fontSize) {
        if (fontSize === "true") {
          changeFontSize(true);
        } else {
          changeFontSize(false);
        }
      }
    })();
  }, []);

  /**
   * Função de acessibilidade para mudar tamanho de fonte do site
   * @param {Boolean} option opção escolhida para mudança de tamanho da fonte
   */
  const changeFontSize = (option) => {
    if (option === true) {
      document.body.classList.add("change-fontsize");
      localStorage.setItem("@Ceprevi:fontSize", true);
    } else {
      document.body.classList.remove("change-fontsize");
      localStorage.setItem("@Ceprevi:fontSize", false);
    }
  };

  /**
   * Função de acessibilidade para mudar cores do site
   * @param {Number} option opção escolhida para mudança de cores
   */
  const changeColors = (option) => {
    const navBar = document.getElementsByClassName("navbar")[0];
    const footer = document.getElementsByTagName("footer")[0];
    const btns = document.getElementsByClassName("btn");
    const breadcrumb = document.getElementsByClassName("breadcrumb");

    if (option === 1) {
      document.body.classList.remove("contrast1", "contrast2");

      navBar.classList.add("navbar-light");
      navBar.classList.remove("navbar-dark");

      footer.classList.add("danger-color-dark");
      footer.classList.remove("black");

      Object.keys(btns).forEach((i) => {
        btns[i].classList.remove("btn-dark");
      });

      Object.keys(breadcrumb).forEach((i) => {
        breadcrumb[i].classList.remove("white-text", "black");
      });

      localStorage.setItem("@Ceprevi:theme", 1);
    } else if (option === 2) {
      document.body.classList.remove("contrast2");
      document.body.classList.add("contrast1");

      navBar.classList.remove("navbar-light");
      navBar.classList.add("navbar-dark");

      footer.classList.remove("danger-color-dark");
      footer.classList.add("black");

      Object.keys(btns).forEach((i) => {
        btns[i].classList.add("btn-dark");
      });

      Object.keys(breadcrumb).forEach((i) => {
        breadcrumb[i].classList.add("white-text", "black");
      });

      localStorage.setItem("@Ceprevi:theme", 2);
    } else if (option === 3) {
      document.body.classList.remove("contrast1");
      document.body.classList.add("contrast2");

      navBar.classList.remove("navbar-light");
      navBar.classList.add("navbar-dark");

      footer.classList.remove("danger-color-dark");
      footer.classList.add("black");

      Object.keys(btns).forEach((i) => {
        btns[i].classList.add("btn-dark");
      });

      Object.keys(breadcrumb).forEach((i) => {
        breadcrumb[i].classList.add("white-text", "black");
      });

      localStorage.setItem("@Ceprevi:theme", 3);
    }
  };

  return (
    <div className="accessibility-bar">
      <div className="container-custom">
        <div className="option" onClick={() => changeColors(1)}>
          &nbsp;
          <div className="red rsp"></div>&nbsp;
          <div className="white"></div>&nbsp;
          <div className="black-ico psr"></div>&nbsp;
          <span>Cores originais&nbsp;</span>
        </div>
        <div className="option" onClick={() => changeColors(2)}>
          &nbsp;
          <div className="black-ico rsp"></div>&nbsp;
          <div className="white"></div>&nbsp;
          <div className="yellow psr"></div>&nbsp;
          <span>Preto, branco e amarelo&nbsp;</span>
        </div>
        <div className="option" onClick={() => changeColors(3)}>
          &nbsp;
          <div className="black-ico rsp"></div>&nbsp;
          <div className="white"></div>&nbsp;
          <span>Preto e branco</span>&nbsp;
        </div>
        <div className="option-fontsize" onClick={() => changeFontSize(true)}>
          &nbsp;&nbsp;&nbsp;
          <span>
            <strong>A+</strong>
          </span>
          &nbsp;&nbsp;&nbsp;
        </div>
        <div className="option-fontsize" onClick={() => changeFontSize(false)}>
          &nbsp;&nbsp;&nbsp;
          <span>
            <strong>A-</strong>
          </span>
          &nbsp;&nbsp;&nbsp;
        </div>
      </div>
    </div>
  );
};

export default AccessibilityBar;
